import React, { useEffect, useState } from "react";
import { CircularProgress, Box, TextField, Autocomplete } from "@mui/material";
import { fetchDataWithRetries } from "../../Component/function/FunctionApi";

const RepresentativeSelector = ({
  value,
  onChange,
  label = "اختر المندوب",
  disabled = false,
  fullWidth = true,
  variant = "outlined",
  sx = {},
  includeNoRepresentative = true,
}) => {
  const [selectedValue, setSelectedValue] = useState(null);
  const [representatives, setRepresentatives] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    if (value === "") {
      setSelectedValue(null);
    } else if (value && representatives.length > 0) {
      if (value === "null") {
        setSelectedValue({ id: "null", fullName: "_" });
      } else {
        const selectedRep = representatives.find(rep => rep.id === value);
        setSelectedValue(selectedRep || null);
      }
    }
  }, [value, representatives]);

  useEffect(() => {
    const fetchRepresentatives = async () => {
      try {
        setIsLoading(true);
        setIsError(false);
        await fetchDataWithRetries(
          "Represntative/get-Represntatives",
          setRepresentatives,
          (status) => {
            if (status === "error") {
              setIsError(true);
            }
          }
        );
      } catch (error) {
        console.error("Error fetching representatives:", error);
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    };

    fetchRepresentatives();
  }, []);

  const handleChange = (event, newValue) => {
    setSelectedValue(newValue);
    if (onChange) {
      onChange({
        target: {
          value: newValue ? newValue.id : "",
          name: "representativeId"
        }
      });
    }
  };

  const getOptions = () => {
    const options = [...(representatives?.data || [])];
    if (includeNoRepresentative) {
      options.unshift({ id: "null", fullName: "_" });
    }
    return options;
  };

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" p={2}>
        <CircularProgress size={24} />
      </Box>
    );
  }

  if (isError) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" p={2}>
        <span className="text-red-500">حدث خطأ في تحميل البيانات</span>
      </Box>
    );
  }

  return (
    <Autocomplete
      value={selectedValue}
      onChange={handleChange}
      options={getOptions()}
      getOptionLabel={(option) => option?.fullName || ""}
      isOptionEqualToValue={(option, value) => option?.id === value?.id}
      disabled={disabled}
      fullWidth={fullWidth}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          variant={variant}
          sx={{
            marginBottom: 2,
            ...sx,
          }}
        />
      )}
      renderOption={(props, option) => (
        <li {...props} key={option.id}>
          {option.fullName}
        </li>
      )}
      noOptionsText="لا توجد نتائج"
      loadingText="جاري التحميل..."
      clearText="مسح"
      closeText="إغلاق"
      openText="فتح"
    />
  );
};

export default RepresentativeSelector; 